<ng-container *transloco="let t">
  <div class="admin-card">
    <app-competitor-table [languages]="languages" [filteringEnabled]="true" [displayRaceName]="true" [event]="event"
                          [raceSettingsList]="raceSettingsList"
                          [applicationFormSettingsList]="applicationFormSettingsList"
                          [showEmptyState]="false" [showHeader]="false" [competitors]="competitors" [isEventView]="true"
                          [isAdmin]="true" [showLoadMoreButton]="true" (filterChange)="onFilterChange($event)">
      <div slot="competitorTableAdminTrailingWidgets">
        <app-admin-actions-header (onExportToPdf)="onGetFileFromServer('pdf')"
                                  (onExportToXls)="onGetFileFromServer('xlsx')">
          <div slot="leadingWidgets">
          </div>
          <div slot="trailingWidgets">
            <div class="pe-3">
              <app-rounded-button [label]="t('race.management.competitors.register')" (onClick)="onRegisterToRace()"
                                  [isDisabled]="disableRegisterToRace"><i class="bi bi-plus-circle pe-2"></i>
              </app-rounded-button>
            </div>
          </div>
        </app-admin-actions-header>
      </div>
    </app-competitor-table>
  </div>
</ng-container>
